export const CurrencyFormatter = (val: number) => new Intl.NumberFormat().format(val)


